import React from 'react';
import { Tray } from '../../../components/elements';
import { isSurveyTemplateElementData } from '../../../components/Surveys/isSurveyTemplateElementData';
import { isSurveyTemplateUnitData } from '../../../components/Surveys/isSurveyTemplateUnitData';
import { ISurveyTemplateElementData } from '../../../components/Surveys/ISurveyTemplateElementData';
import { ISurveyTemplateElementGroupData } from '../../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { SurveyEditAoBasisgegevensElement } from './SurveyEditAoBasisgegevensElement';
import { SurveyEditAoBasisgegevensUnit } from './SurveyEditAoBasisgegevensUnit';

export function SurveyEditAoBasisgegevensDecomposition(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateElementData
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    if (isSurveyTemplateElementData(props)) {
        return <SurveyEditAoBasisgegevensElement {...props} />;
    } else if (isSurveyTemplateUnitData(props)) {
        return <SurveyEditAoBasisgegevensUnit {...props} />;
    }
    return <Tray>&nbsp;</Tray>;
}
